import Image from "next/image";

import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import Heading from "sections/nfcTagsPage/Heading";

import styles from "./styles";

interface Entity {
  title: string;
  logo: string;
  description: string;
  logoWidth?: number;
  logoHeight?: number;
}

interface WhatIsSectionProps {
  heading?: string;
  entities: Entity[];
  caseStudyFolder?: string;
  boxProps?: BoxProps;
}

const WhatIsSection: FC<WhatIsSectionProps> = ({ 
  heading = "WHAT IS",
  entities,
  caseStudyFolder = "pages/cases/puma",
  boxProps 
}) => {
  const isSingleEntity = entities.length === 1;

  return (
    <Box component="section" display="grid" {...boxProps}>
      <Container>
        <Heading heading={heading} />

        <Box sx={styles.contentWrapper(isSingleEntity)}>
          {entities.map((entity, index) => (
            <Box key={index} sx={styles.card}>
              <Typography variant="h2" sx={styles.cardTitle}>
                {entity.title}
              </Typography>
              <Box sx={styles.logoWrapper}>
                <Image
                  src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/${caseStudyFolder}/${entity.logo}`}
                  width={entity.logoWidth || 200}
                  height={entity.logoHeight || 200}
                  alt={entity.title}
                  style={{
                    width: "auto",
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Typography variant="h4" sx={styles.cardDescription}>
                {entity.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default WhatIsSection;

